import ErrorScreen404 from "./404";
import ErrorScreenForbidden from "./Forbidden";

export { ErrorScreen404, ErrorScreenForbidden };
